import { api } from "../api";
import axios from "axios";


export const getFermes = async () => {
  const response = await axios.get(api + 'ferme/',
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
  return response.data;
}

export const getFermesE = async () => {
  const response = await axios.get(api+'fermeE',
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
  return response.data;
}

export const updateFerme = async (fermeId, fermeData) => {
  const response = await axios.put(api + `ferme/${fermeId}`, fermeData, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      Accept: "application/json",
    }
  });
  return response.data;
}